<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <i class="fas fa-tools dialog-icon"></i>
            <span class="te-title">{{'quotation.chooseOption' | translate}}</span>
        </div>
        <div class="td-cnt-body-dto">
            <teiasoft-button (onClick)="onSelectGenerateClick()" [type]="'tb-primary'"
                [text]="'quotation.goToTool' | translate" [isMobile]="isMobile"></teiasoft-button>
            <!-- <div class="or-divider">
                <span>{{ 'commons.or' | translate }}</span>
            </div> -->
            <div>
                <!-- Hidden file input -->
                <input id="file-upload" class="file-upload-input" type="file" (change)="onFileSelected($event)"
                    accept="application/pdf" />

                <!-- Button styled as a file input trigger -->
                <label for="file-upload" class="teia-button tb-primary file-upload-label">
                    {{ 'quotation.uploadPdfDescription' | translate }}
                </label>
            </div>
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onCancelClick()" class="mr-5" [type]="'tb-cancel'" [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>